<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          dark
          v-on="on"
          size="18"
          @click="goToPreviousExtent"
          :disabled="previousExtentUnavailable"
          >mdi-arrow-left-bold-box-outline</v-icon
        ></template
      >
      <span>Forrige utsnitt</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          dark
          v-on="on"
          size="18"
          @click="goToNextExtent"
          :disabled="nextExtentUnavailable"
          >mdi-arrow-right-bold-box-outline</v-icon
        ></template
      >
      <span>Neste utsnitt</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MapExtentHistoryNavigation",
  data: () => {
    return {
      prevExtent: false,
      preExtent: null,
      currentExtent: null,
      extentHistory: [],
      extentHistoryIndx: 0,
      nextExtent: false
    };
  },
  computed: {
    ...mapState(["extent", "is3d"]),
    currentView() {
      return this.is3d ? this.$theSceneViewObject : this.$theMapViewObject;
    },
    previousExtentUnavailable() {
      return this.extentHistory.length === 0 || this.extentHistoryIndx === 0;
    },
    nextExtentUnavailable() {
      return (
        this.extentHistory.length === 0 ||
        this.extentHistoryIndx === this.extentHistory.length - 1
      );
    }
  },
  watch: {
    extent(newVal) {
      this.extentChangeHandler(newVal);
    }
  },
  methods: {
    extentChangeHandler: function(evt) {
      if (this.prevExtent || this.nextExtent) {
        this.currentExtent = evt;
      } else {
        this.preExtent = this.currentExtent;
        this.currentExtent = evt;

        this.extentHistory.push({
          preExtent: this.preExtent,
          currentExtent: this.currentExtent
        });
        this.extentHistoryIndx = this.extentHistory.length - 1;
      }
      this.prevExtent = this.nextExtent = false;
    },
    goToPreviousExtent: function() {
      if (this.extentHistory[this.extentHistoryIndx].preExtent) {
        this.prevExtent = true;
        this.currentView.goTo(
          this.extentHistory[this.extentHistoryIndx].preExtent
        );
        this.extentHistoryIndx--;
      }
    },
    goToNextExtent: function() {
      this.nextExtent = true;
      this.extentHistoryIndx++;
      this.currentView.goTo(
        this.extentHistory[this.extentHistoryIndx].currentExtent
      );
    }
  }
};
</script>

<style></style>
